// Demo data - realistic TSCORP sample data
// All names are fictional (개인정보보호법 준수)

const EMPLOYEES = [
  { id: 'TS2600001', name: '김도현', team: '경영지원팀', position: '부장', age: 48, gender: 'male', hire_date: '2012-03-02', salary: 72000000, region: '서울 강남구' },
  { id: 'TS2600002', name: '이서연', team: '경영지원팀', position: '대리', age: 31, gender: 'female', hire_date: '2020-01-06', salary: 42000000, region: '서울 송파구' },
  { id: 'TS2600003', name: '박준호', team: '경영지원팀', position: '사원', age: 27, gender: 'male', hire_date: '2024-03-04', salary: 34000000, region: '경기 성남시' },
  { id: 'TS2600004', name: '최민지', team: '영업팀', position: '팀장', age: 43, gender: 'female', hire_date: '2014-07-01', salary: 68000000, region: '서울 서초구' },
  { id: 'TS2600005', name: '정우진', team: '영업팀', position: '과장', age: 37, gender: 'male', hire_date: '2017-09-01', salary: 55000000, region: '서울 강동구' },
  { id: 'TS2600006', name: '강하은', team: '영업팀', position: '대리', age: 30, gender: 'female', hire_date: '2021-03-02', salary: 40000000, region: '경기 하남시' },
  { id: 'TS2600007', name: '윤성민', team: '영업팀', position: '사원', age: 26, gender: 'male', hire_date: '2024-09-01', salary: 33000000, region: '서울 송파구' },
  { id: 'TS2600008', name: '한지수', team: '영업팀', position: '사원', age: 25, gender: 'female', hire_date: '2025-03-03', salary: 32000000, region: '경기 광주시' },
  { id: 'TS2600009', name: '임태현', team: '연구개발팀', position: '팀장', age: 45, gender: 'male', hire_date: '2013-01-02', salary: 75000000, region: '서울 관악구' },
  { id: 'TS2600010', name: '송예진', team: '연구개발팀', position: '과장', age: 38, gender: 'female', hire_date: '2016-04-01', salary: 58000000, region: '경기 과천시' },
  { id: 'TS2600011', name: '오재혁', team: '연구개발팀', position: '대리', age: 33, gender: 'male', hire_date: '2019-07-01', salary: 46000000, region: '서울 동작구' },
  { id: 'TS2600012', name: '배수아', team: '연구개발팀', position: '대리', age: 32, gender: 'female', hire_date: '2020-03-02', salary: 44000000, region: '경기 안양시' },
  { id: 'TS2600013', name: '조현우', team: '연구개발팀', position: '사원', age: 28, gender: 'male', hire_date: '2023-03-06', salary: 36000000, region: '서울 강서구' },
  { id: 'TS2600014', name: '신지은', team: '연구개발팀', position: '사원', age: 26, gender: 'female', hire_date: '2024-07-01', salary: 34000000, region: '경기 부천시' },
  { id: 'TS2600015', name: '서동훈', team: '품질관리팀', position: '팀장', age: 44, gender: 'male', hire_date: '2013-09-01', salary: 70000000, region: '서울 마포구' },
  { id: 'TS2600016', name: '유지현', team: '품질관리팀', position: '과장', age: 36, gender: 'female', hire_date: '2018-01-02', salary: 52000000, region: '경기 고양시' },
  { id: 'TS2600017', name: '권혁준', team: '품질관리팀', position: '대리', age: 31, gender: 'male', hire_date: '2021-07-01', salary: 41000000, region: '서울 은평구' },
  { id: 'TS2600018', name: '문소현', team: '품질관리팀', position: '사원', age: 27, gender: 'female', hire_date: '2024-01-02', salary: 34000000, region: '경기 파주시' },
  { id: 'TS2600019', name: '장민수', team: '생산팀', position: '팀장', age: 46, gender: 'male', hire_date: '2011-03-02', salary: 72000000, region: '인천 남동구' },
  { id: 'TS2600020', name: '홍유리', team: '생산팀', position: '과장', age: 39, gender: 'female', hire_date: '2016-01-04', salary: 56000000, region: '인천 연수구' },
  { id: 'TS2600021', name: '남기훈', team: '생산팀', position: '대리', age: 34, gender: 'male', hire_date: '2019-03-04', salary: 45000000, region: '경기 시흥시' },
  { id: 'TS2600022', name: '안미래', team: '생산팀', position: '사원', age: 28, gender: 'female', hire_date: '2023-07-03', salary: 35000000, region: '인천 부평구' },
  { id: 'TS2600023', name: '구본석', team: '생산팀', position: '사원', age: 25, gender: 'male', hire_date: '2025-01-02', salary: 32000000, region: '경기 안산시' },
  { id: 'TS2600024', name: '하은서', team: 'IT개발팀', position: '팀장', age: 42, gender: 'female', hire_date: '2015-01-05', salary: 73000000, region: '서울 강남구' },
  { id: 'TS2600025', name: '류재현', team: 'IT개발팀', position: '과장', age: 35, gender: 'male', hire_date: '2018-07-02', salary: 54000000, region: '서울 서초구' },
  { id: 'TS2600026', name: '노하린', team: 'IT개발팀', position: '대리', age: 30, gender: 'female', hire_date: '2021-09-01', salary: 43000000, region: '경기 용인시' },
  { id: 'TS2600027', name: '전승우', team: 'IT개발팀', position: '대리', age: 29, gender: 'male', hire_date: '2022-03-07', salary: 42000000, region: '서울 영등포구' },
  { id: 'TS2600028', name: '양세은', team: 'IT개발팀', position: '사원', age: 26, gender: 'female', hire_date: '2024-03-04', salary: 35000000, region: '경기 수원시' },
  { id: 'TS2600029', name: '백도윤', team: 'IT개발팀', position: '사원', age: 24, gender: 'male', hire_date: '2025-09-01', salary: 32000000, region: '서울 관악구' },
];

// ========== Pre-built AI Analysis Data (OpenAI 호출 없이 사전 분석 결과) ==========
const EMPLOYEE_ANALYSES: Record<string, { analysis: any; swot: any }> = {
  TS2600001: {
    analysis: {
      career_analysis: '김도현 부장은 14년차 경영관리 전문가로, TS Scientific 설립 초기부터 경영지원 전반을 담당해온 핵심 인력입니다. 인사·총무·회계를 아우르는 폭넓은 경험이 강점이나, 최신 HR Tech 트렌드 습득이 필요합니다.',
      strengths: ['14년간 경영지원 전반 경험으로 조직 운영 안정성 확보', '인사·총무·회계 전 영역 겸무 가능한 멀티플레이어', '신입사원 온보딩 및 조직 문화 형성에 핵심 역할'],
      weaknesses: ['HR 데이터 분석 및 BI 도구 활용 역량 부족', '디지털 전환(ERP, 그룹웨어) 관련 기술 이해 제한적', '후임 양성 계획 미비로 핵심인재 리스크 존재'],
      utilization: ['전사 HR 시스템 구축 프로젝트 총괄 적임자', 'CHRO(인사총괄) 후보로 경영진 육성 대상', '신규 입사자 멘토링 프로그램 운영'],
      risk_factors: ['14년 근속 + 부장직으로 퇴직 시 업무 공백 심각', '연봉 7,200만원으로 시장 대비 보통 수준, 이직 가능성 존재', '번아웃 징후 관찰 필요 (연차 사용률 확인 권장)'],
      development_priority: ['HR Analytics 과정 이수 (피플 애널리틱스)', 'ERP/그룹웨어 관리자 교육', '리더십 코칭 프로그램 참여'],
      market_value: { salary_assessment: '적정', competitiveness: '중' },
    },
    swot: {
      strengths: ['14년 경영관리 경력으로 조직 내 신뢰도 최상', '인사·총무·회계 전반 겸무 능력', '조직 문화와 역사에 대한 깊은 이해'],
      weaknesses: ['최신 HR Tech 도구 활용 미숙', '데이터 기반 의사결정 역량 보강 필요', '1인 의존도 높아 업무 분산 시급'],
      opportunities: ['HR 시스템 디지털 전환 리더로 성장 가능', '그룹사 확장 시 CHRO 역할 수행 기회', '후배 양성으로 리더십 역량 강화'],
      threats: ['경영지원 인력 부족으로 인한 만성 업무 과부하', '핵심인재 이탈 시 대체 인력 확보 어려움', '급변하는 HR 규제 환경 대응 부담'],
    },
  },
  TS2600002: {
    analysis: {
      career_analysis: '이서연 대리는 6년차 경영지원 담당자로, 총무 업무를 중심으로 안정적인 업무 수행을 보여주고 있습니다. 멀티태스킹 능력이 우수하며, 인사기획 영역으로의 확장이 기대됩니다.',
      strengths: ['빠른 업무 습득력과 멀티태스킹 능력', '전사 부서와의 원활한 소통 능력', '꼼꼼한 문서 관리 및 행정 처리'],
      weaknesses: ['인사기획 경험 부족으로 전략적 사고 훈련 필요', 'Excel/데이터 분석 역량 보통 수준', '의사결정 주도 경험 제한적'],
      utilization: ['인사기획 업무 참여로 역할 확장', '급여/4대보험 업무 전담자로 전문성 강화', '사내 교육 프로그램 운영 담당'],
      risk_factors: ['총무 업무 위주로 경력 성장 정체 가능성', '급여 대비 업무 범위가 넓어 이직 리스크', '경영지원 3인 체제에서 개인 업무 부담 과중'],
      development_priority: ['인사관리사 자격증 취득', 'Excel 고급 과정 및 데이터 분석 교육', '리더십 기초 과정'],
      market_value: { salary_assessment: '적정', competitiveness: '중' },
    },
    swot: {
      strengths: ['뛰어난 멀티태스킹과 업무 처리 속도', '부서 간 커뮤니케이션 허브 역할', '성실하고 꼼꼼한 업무 스타일'],
      weaknesses: ['전략적 인사기획 경험 부족', '데이터 분석 도구 활용 미숙', '주도적 의사결정 경험 제한'],
      opportunities: ['인사기획 참여로 커리어 확장 가능', 'HR 시스템 도입 시 핵심 운영자 역할', '급여/복리후생 전문가로 성장'],
      threats: ['3인 팀의 과도한 업무 부담', '경력 성장 경로 불명확', '시장 대비 보상 경쟁력 점검 필요'],
    },
  },
  TS2600003: {
    analysis: {
      career_analysis: '박준호 사원은 2년차 신입으로 경영지원 기초 업무를 학습 중입니다. 적극적인 자세와 빠른 학습 속도를 보이고 있으나, 실무 경험 축적이 필요합니다.',
      strengths: ['적극적인 학습 자세와 빠른 적응력', '디지털 네이티브로 IT 도구 활용 능숙', '밝은 성격으로 팀 분위기 긍정적 기여'],
      weaknesses: ['실무 경험 부족으로 독립적 업무 수행 제한', '비즈니스 문서 작성 능력 보강 필요', '업무 우선순위 설정 능력 미흡'],
      utilization: ['김도현 부장의 OJT 프로그램으로 실무 역량 빠른 성장', '디지털 전환 프로젝트 주니어 담당자', '사내 행사 기획 및 운영'],
      risk_factors: ['신입 이탈률이 높은 시기(1~2년차)', '성장 경로가 불명확하면 동기 저하 우려', '소규모 팀에서 다양한 경험 기회 제한'],
      development_priority: ['경영관리 기초 과정 이수', '비즈니스 문서 작성 교육', '엑셀/데이터 처리 기초'],
      market_value: { salary_assessment: '적정', competitiveness: '중하' },
    },
    swot: {
      strengths: ['빠른 학습력과 적극적 자세', 'IT 도구 활용 능숙 (디지털 네이티브)', '긍정적 팀 분위기 조성'],
      weaknesses: ['실무 경험 부족', '비즈니스 문서 작성 미숙', '업무 독립성 부족'],
      opportunities: ['OJT를 통한 빠른 성장 가능', '디지털 전환 프로젝트 참여 기회', '다양한 경영지원 업무 경험 축적'],
      threats: ['신입 이탈률 높은 시기', '소규모 팀의 제한된 성장 기회', '업무 과부하로 인한 조기 번아웃'],
    },
  },
  TS2600004: {
    analysis: {
      career_analysis: '최민지 팀장은 12년차 영업 전문가로, 고객 네트워크 구축과 매출 목표 달성에 탁월한 성과를 보여왔습니다. 전년 대비 매출 12% 성장을 달성한 핵심 인재이나, 팀원 초과근무 관리에 주의가 필요합니다.',
      strengths: ['12년 영업 경험으로 확보한 광범위한 고객 네트워크', '매출 목표 초과 달성 실적 (전년 대비 +12%)', '팀원 멘토링과 선후배 문화 정착에 기여'],
      weaknesses: ['CRM 시스템 활용도 낮아 영업 파이프라인 가시성 부족', '팀원 초과근무 관리 미흡 (정우진 과장 51.5h)', '데이터 기반 영업 전략 수립 역량 보강 필요'],
      utilization: ['영업 전략 수립 및 신시장 개척 리더', '주요 고객사 관계 관리 총괄', '신입 영업 사원 교육 프로그램 운영'],
      risk_factors: ['팀 초과근무 미관리 시 근로기준법 위반 리스크', '핵심 고객사 의존도 높아 분산 필요', '팀장 업무 과부하로 번아웃 가능성'],
      development_priority: ['CRM 시스템 고급 활용 교육', '영업 데이터 분석 역량 강화', '팀 매니지먼트 고급 과정'],
      market_value: { salary_assessment: '적정', competitiveness: '중상' },
    },
    swot: {
      strengths: ['12년 영업 경력의 깊이 있는 고객 인사이트', '매출 성장 목표 지속적 초과 달성', '팀 내 멘토링 문화 정착 리더'],
      weaknesses: ['디지털 영업 도구 활용 미숙', '팀원 근무시간 관리 미흡', '정량적 영업 분석 역량 부족'],
      opportunities: ['CRM 도입으로 영업 효율 대폭 향상 가능', '신시장 개척 프로젝트 리드 적임자', '영업 교육 체계 구축으로 조직 기여'],
      threats: ['핵심 고객사 이탈 시 매출 급감 리스크', '52시간제 위반 리스크 (팀원 관리)', '경쟁사 스카우트 대상'],
    },
  },
  TS2600005: {
    analysis: {
      career_analysis: '정우진 과장은 9년차 기술영업 전문가로, 최근 과장 승진 후 역할 확대 중입니다. 기술적 이해를 바탕으로 한 영업 역량이 강점이나, 주 51.5시간 초과근무가 위험 수준입니다.',
      strengths: ['기술 이해도를 바탕으로 한 전문적 기술영업 역량', '2025년 과장 승진으로 성장 동력 확보', '신규 거래처 개척 능력 우수'],
      weaknesses: ['주 51.5시간 초과근무로 52시간제 위반 임박', '업무 위임 능력 부족으로 개인 부담 과중', '영업 관련 문서 작성/보고 역량 보강 필요'],
      utilization: ['기술영업 전략 수립 핵심 담당자', '제품 기술 교육 강사 역할', '신규 시장 진출 선봉대'],
      risk_factors: ['52시간제 위반 임박 — 즉각적 조치 필수', '과도한 업무로 건강/이직 리스크', '승진 직후 기대치 관리 필요'],
      development_priority: ['업무 효율화 및 시간 관리 코칭', '프레젠테이션/제안서 작성 교육', '영업 관리자 리더십 과정'],
      market_value: { salary_assessment: '약간 낮음', competitiveness: '중상' },
    },
    swot: {
      strengths: ['기술+영업 융합 역량', '신규 거래처 개척 실적', '최근 승진으로 높은 동기부여'],
      weaknesses: ['만성적 초과근무 (주 51.5h)', '업무 위임 미숙', '문서 작성 역량 보통'],
      opportunities: ['기술영업 전문가로 커리어 차별화', '해외 시장 진출 시 핵심 역할', '과장 승진 후 리더십 경험 축적'],
      threats: ['52시간 상한 위반 리스크 (법적)', '건강 악화 및 번아웃 위험', '경쟁사 기술영업 인재 쟁탈'],
    },
  },
  TS2600006: {
    analysis: {
      career_analysis: '강하은 대리는 5년차 영업 담당자로, 신규 거래처 3건 개척 등 성과를 보이고 있으나, 주 49시간 초과근무가 고위험 수준입니다.',
      strengths: ['신규 거래처 개척 능력 (3건 달성)', '적극적인 고객 응대와 관계 구축', '영업팀 내 중간 허리 역할 수행'],
      weaknesses: ['주 49시간 초과근무로 고위험 수준', '영업 데이터 분석 역량 부족', '장애인 인식개선 교육 미이수 (3월 기한)'],
      utilization: ['핵심 고객 관리 전담자로 성장', '후배(윤성민, 한지수) 실무 교육 담당', '영업 프로세스 표준화 프로젝트 참여'],
      risk_factors: ['초과근무 지속 시 건강/이직 리스크', '법정교육 미이수 관리 필요', '업무량 대비 보상 만족도 확인 필요'],
      development_priority: ['시간 관리 및 업무 효율화', '영업 데이터 분석 기초', '법정교육 즉시 이수'],
      market_value: { salary_assessment: '적정', competitiveness: '중' },
    },
    swot: {
      strengths: ['신규 거래처 개척 실적 우수', '적극적 고객 관계 관리', '팀 내 중간 리더 역할'],
      weaknesses: ['초과근무 고위험', '데이터 분석 역량 부족', '교육 미이수 잔존'],
      opportunities: ['핵심 고객 전담 매니저로 성장', '후배 육성으로 리더십 경험', 'CRM 도입 시 운영 핵심 역할'],
      threats: ['초과근무로 인한 건강 리스크', '교육 미이수 과태료 리스크', '업무 과부하 지속'],
    },
  },
  TS2600007: {
    analysis: {
      career_analysis: '윤성민 사원은 1.5년차 신입 영업 담당자로, 기본 영업 스킬을 습득 중입니다. 법정교육 2건 미이수가 즉시 해결 필요한 과제입니다.',
      strengths: ['적극적인 학습 의지와 빠른 적응력', '고객 응대 기본기 양호', '팀 내 협업 자세 우수'],
      weaknesses: ['개인정보보호·장애인 인식개선 교육 미이수', '독립적 영업 활동 경험 부족', '제품 기술 지식 보강 필요'],
      utilization: ['선배(정우진 과장) 동행 영업으로 실전 경험 축적', '영업 지원 업무 전담 (제안서, 견적서 작성)', '사내 제품 교육 이수 후 기술영업 역량 강화'],
      risk_factors: ['법정교육 미이수 과태료 리스크', '신입 이탈률 높은 시기', '영업 성과 압박에 따른 스트레스'],
      development_priority: ['법정 필수교육 즉시 이수', '제품 기술 교육 프로그램 참여', '영업 기초 스킬 교육'],
      market_value: { salary_assessment: '적정', competitiveness: '중하' },
    },
    swot: {
      strengths: ['적극적 학습 의지', '고객 응대 기본기', '팀 협업 자세'],
      weaknesses: ['법정교육 미이수', '독립 영업 경험 부족', '기술 지식 부족'],
      opportunities: ['선배 동행 영업으로 빠른 성장', '기술영업 전문가 경로', '영업 프로세스 정립 참여'],
      threats: ['법정교육 과태료', '신입 이탈 리스크', '성과 압박 스트레스'],
    },
  },
  TS2600008: {
    analysis: {
      career_analysis: '한지수 사원은 1년차 신입으로, 영업팀에서 기초 업무를 배우고 있습니다. 성희롱 예방·산업안전보건 교육 미이수가 즉시 해결 과제입니다.',
      strengths: ['밝고 적극적인 성격으로 고객 첫인상 우수', '빠른 학습 속도', '디지털 도구 활용 능숙'],
      weaknesses: ['성희롱 예방·산업안전보건 교육 미이수', '영업 실무 경험 전무', '비즈니스 매너 교육 필요'],
      utilization: ['고객 응대 교육 프로그램 참여', '영업 자료 정리 및 CRM 데이터 입력', '온라인 마케팅 영업 지원'],
      risk_factors: ['법정교육 미이수 리스크', '신입 조기 이탈 가능성', '업무 적응 스트레스'],
      development_priority: ['법정 필수교육 즉시 이수', '영업 기초 실무 교육', '비즈니스 커뮤니케이션 과정'],
      market_value: { salary_assessment: '적정', competitiveness: '중하' },
    },
    swot: {
      strengths: ['밝은 성격과 적극성', '빠른 학습 속도', '디지털 도구 활용'],
      weaknesses: ['법정교육 미이수', '실무 경험 전무', '비즈니스 매너 부족'],
      opportunities: ['멘토링 프로그램으로 빠른 성장', '디지털 영업 분야 선도', '고객관계 관리 전문가 경로'],
      threats: ['법정교육 과태료', '조기 이탈 위험', '업무 적응 실패 가능성'],
    },
  },
  TS2600009: {
    analysis: {
      career_analysis: '임태현 팀장은 13년차 R&D 리더로, 특허 3건 보유 및 차세대 제품 개발을 주도하는 핵심 인재입니다. 기술 방향 설정 능력이 탁월하나, 연차 사용률이 낮아 번아웃 관리가 필요합니다.',
      strengths: ['13년 R&D 경험과 특허 3건 보유', '차세대 제품 프로토타입 개발 주도', '팀원 기술 성장을 위한 지식 공유 문화 조성'],
      weaknesses: ['연차 사용률 20%로 매우 낮음 (번아웃 위험)', 'AI/ML 분야 전문 인력 확보 지연', '코드 리뷰 프로세스 미정립'],
      utilization: ['CTO/기술이사 후보로 임원 육성 대상', '차세대 기술 전략 수립 총괄', '사내 기술 세미나 강사 및 멘토'],
      risk_factors: ['핵심 기술 인재 이탈 시 R&D 역량 급감', '연차 미사용으로 번아웃 리스크 높음', '팀원 초과근무(송예진 47.5h) 관리 필요'],
      development_priority: ['AI/ML 기술 리더 교육', 'R&D 매니지먼트 고급 과정', '워라밸 및 자기관리 프로그램'],
      market_value: { salary_assessment: '적정', competitiveness: '상' },
    },
    swot: {
      strengths: ['13년 R&D 경험과 특허 보유', '기술 방향 설정 탁월', '지식 공유 문화 리더'],
      weaknesses: ['연차 사용률 극히 낮음', 'AI/ML 인력 확보 지연', '프로세스 체계화 미흡'],
      opportunities: ['CTO 후보로 경영 참여 기회', 'AI/ML 신기술 적용 프로젝트 리드', '기술 조직 확대 시 핵심 리더'],
      threats: ['핵심인재 이탈 시 대체 불가', '번아웃으로 인한 생산성 저하', '기술 트렌드 변화 속도'],
    },
  },
  TS2600010: {
    analysis: {
      career_analysis: '송예진 과장은 10년차 연구원으로, 팀 내 시니어 역할을 수행하며 기술적 깊이가 우수합니다. 주 47.5시간 초과근무 경고 수준이 관리 포인트입니다.',
      strengths: ['10년 연구개발 경험의 기술적 깊이', '팀 내 시니어로서 후배 기술 지도', '프로젝트 일정 관리 능력 양호'],
      weaknesses: ['주 47.5시간 초과근무 경고 수준', '업무 위임 및 분산 미흡', '논문/특허 성과 부족'],
      utilization: ['기술 검토 위원회 참여', '후배 연구원 기술 멘토링', '제품 기술 문서 작성 총괄'],
      risk_factors: ['초과근무 지속 시 건강/성과 저하', '인력 보강 없이 업무 부담 가중', '기술 성장 정체 가능성'],
      development_priority: ['시간 관리 및 업무 효율화 코칭', '특허 출원 지원 프로그램', 'AI/ML 기초 교육'],
      market_value: { salary_assessment: '적정', competitiveness: '중상' },
    },
    swot: {
      strengths: ['깊이 있는 기술 역량', '시니어 멘토 역할', '일정 관리 능력'],
      weaknesses: ['초과근무 경고', '업무 위임 미숙', '연구 성과물 부족'],
      opportunities: ['기술 리더로 성장 경로', '특허 출원 지원', '신기술 연구 참여'],
      threats: ['초과근무 건강 리스크', '인력 부족 지속', '기술 정체 위험'],
    },
  },
  TS2600011: {
    analysis: {
      career_analysis: '오재혁 대리는 7년차 연구원으로, 2024년 10월 품질관리팀→연구개발팀 이동 후 빠르게 적응하고 있습니다. 품질 관점의 코드 리뷰 참여가 팀 전체 품질 향상에 기여하고 있습니다.',
      strengths: ['품질관리+연구개발 이중 경험으로 독특한 관점 보유', '코드 리뷰 참여로 팀 코드 품질 향상 기여', '꼼꼼하고 체계적인 업무 스타일'],
      weaknesses: ['연차 12일 잔여로 소멸 위험 (6월 만료)', '새 팀 적응 과정에서 기술 스택 전환 중', '주도적 프로젝트 리딩 경험 부족'],
      utilization: ['품질+개발 융합 역할 (QA 프로세스 개선)', '코드 리뷰 체계 구축 리더', '테스트 자동화 프로젝트 핵심 담당'],
      risk_factors: ['연차 소멸 위험 — 휴가 사용 독려 필요', '팀 이동 초기 적응 스트레스', '업무 정체감 발생 시 이직 고려 가능'],
      development_priority: ['테스트 자동화 프레임워크 교육', '연구개발 관련 전문 기술 심화', 'Agile/Scrum 프로세스 교육'],
      market_value: { salary_assessment: '적정', competitiveness: '중' },
    },
    swot: {
      strengths: ['품질+개발 이중 경험', '코드 품질 향상 기여', '체계적 업무 스타일'],
      weaknesses: ['연차 소멸 위험', '기술 스택 전환 중', '프로젝트 리딩 경험 부족'],
      opportunities: ['QA 프로세스 개선 리더', '테스트 자동화 전문가', '융합 역량 차별화'],
      threats: ['적응 스트레스', '연차 소멸', '업무 정체감'],
    },
  },
  TS2600012: {
    analysis: {
      career_analysis: '배수아 대리는 6년차 연구원으로, 안정적인 실무 역량을 보유하고 있습니다. 팀 내 중간 관리 역할을 수행하며 후배 지도에 기여하고 있습니다.',
      strengths: ['안정적이고 꾸준한 업무 수행', '후배 연구원 실무 지도 역할', '기술 문서 작성 능력 우수'],
      weaknesses: ['적극적 도전보다 안정 지향적 성향', '신기술 탐구 의지 보통', '리더십 발휘 기회 제한적'],
      utilization: ['기술 문서화 및 지식 관리 체계 구축', '신입 연구원 OJT 담당', '프로젝트 일정/이슈 관리'],
      risk_factors: ['성장 정체 시 동기 저하 우려', '루틴 업무 중심으로 역량 확장 제한', '과장 승진 준비 필요'],
      development_priority: ['신기술 연구 프로젝트 참여', '프로젝트 관리(PM) 기초', '과장 승진을 위한 역량 개발'],
      market_value: { salary_assessment: '적정', competitiveness: '중' },
    },
    swot: {
      strengths: ['안정적 실무 역량', '후배 지도 기여', '문서화 능력 우수'],
      weaknesses: ['안정 지향적 성향', '신기술 탐구 보통', '리더십 기회 제한'],
      opportunities: ['지식 관리 체계 구축 리더', 'PM 역량 개발', '과장 승진 기회'],
      threats: ['성장 정체', '루틴 업무 고착', '동기 저하 위험'],
    },
  },
  TS2600013: {
    analysis: {
      career_analysis: '조현우 사원은 3년차 연구원으로, 기술 성장 속도가 양호합니다. 최근 평가 이의제기(C→B)를 통해 적극적으로 성과를 주장하는 모습을 보여주고 있습니다.',
      strengths: ['빠른 기술 성장 속도', '적극적인 성과 주장 및 커뮤니케이션', 'Python 기반 분석 도구 활용 능력'],
      weaknesses: ['프로젝트 전체 관점의 시야 부족', '문서화 습관 미흡', '평가 등급(C)에 대한 불만 관리 필요'],
      utilization: ['데이터 분석 도구 개발 담당', '신기술 PoC(개념검증) 프로젝트 참여', '팀 내 기술 블로그/위키 운영'],
      risk_factors: ['평가 결과 불만으로 동기 저하 가능', '프로젝트 기여도 인정받지 못할 시 이직 고려', '기대치와 현실 간 갭 관리 필요'],
      development_priority: ['프로젝트 관리 기초 교육', '기술 문서화 역량 강화', '셀프 매니지먼트 코칭'],
      market_value: { salary_assessment: '적정', competitiveness: '중' },
    },
    swot: {
      strengths: ['빠른 기술 성장', '적극적 커뮤니케이션', '분석 도구 활용'],
      weaknesses: ['전체 관점 부족', '문서화 미흡', '평가 불만'],
      opportunities: ['데이터 분석 전문가 경로', '신기술 PoC 리드', '기술 블로그 운영'],
      threats: ['평가 불만 이직', '기대치 갭', '동기 저하'],
    },
  },
  TS2600014: {
    analysis: {
      career_analysis: '신지은 사원은 1.5년차 신입으로, 빠른 적응력과 자발적 학습 의지가 돋보입니다. Python 기반 분석 도구 개발에 참여하며 팀 생산성에 기여 중이며, AI/ML 교육 대상자로 추천됩니다.',
      strengths: ['빠른 적응력과 자발적 학습 의지', 'Python 분석 도구 개발 참여로 팀 생산성 기여', '신기술에 대한 높은 관심과 학습 동기'],
      weaknesses: ['실무 경험 축적 필요', '독립적 프로젝트 수행 능력 미흡', '비즈니스 도메인 이해 보강 필요'],
      utilization: ['AI/ML 교육 프로그램 참여 대상자', 'Python 자동화 도구 개발 담당', '팀 내 신기술 리서치 역할'],
      risk_factors: ['성장 기회 부족 시 이직 리스크', '신입 이탈률 높은 시기', '기대 관리 필요'],
      development_priority: ['AI/ML 기초 과정 이수', 'Python 고급 프로그래밍', '프로젝트 참여 확대'],
      market_value: { salary_assessment: '적정', competitiveness: '중' },
    },
    swot: {
      strengths: ['빠른 적응력', '자발적 학습', 'Python 역량'],
      weaknesses: ['실무 경험 부족', '독립 수행 미흡', '도메인 이해 부족'],
      opportunities: ['AI/ML 전문가 성장 경로', '자동화 도구 개발 리드', '신기술 연구 참여'],
      threats: ['성장 기회 부족 시 이탈', '신입 이탈 시기', '기대치 관리'],
    },
  },
  TS2600015: {
    analysis: {
      career_analysis: '서동훈 팀장은 13년차 품질관리 전문가로, 법정교육 이수율 100%를 유지하는 컴플라이언스 모범 팀을 이끌고 있습니다. ISO 인증 준비와 품질 데이터 전산화를 주도하고 있습니다.',
      strengths: ['13년 품질관리 전문 경험', '법정교육 이수율 100% 모범 팀 운영', 'ISO 인증 준비 주도'],
      weaknesses: ['통계적 품질관리(SQC) 역량 보강 필요', '품질 데이터 전산화 미완', '글로벌 인증(FDA 등) 대응 역량 제한'],
      utilization: ['품질 관리 체계 고도화 리더', 'ISO 인증 심사 대응 총괄', '전사 컴플라이언스 자문 역할'],
      risk_factors: ['4인 팀으로 업무 부담 과중', '전산화 지연 시 품질 관리 효율 저하', '글로벌 진출 시 인증 대응 역량 부족'],
      development_priority: ['SQC/SPC 통계 분석 교육', '글로벌 품질 인증 과정', '품질 데이터 분석 도구 활용'],
      market_value: { salary_assessment: '적정', competitiveness: '중상' },
    },
    swot: {
      strengths: ['13년 품질관리 전문성', '컴플라이언스 100% 달성', 'ISO 인증 주도'],
      weaknesses: ['SQC 역량 보강 필요', '데이터 전산화 미완', '글로벌 인증 제한'],
      opportunities: ['품질 관리 체계 고도화', '글로벌 인증 대응 리더', '전사 컴플라이언스 자문'],
      threats: ['소규모 팀 업무 부담', '전산화 지연', '글로벌 경쟁 심화'],
    },
  },
  TS2600016: {
    analysis: {
      career_analysis: '유지현 과장은 8년차 품질관리 담당자로, 체계적인 문서화 능력이 ISO 인증 준비에 핵심 역할을 하고 있습니다.',
      strengths: ['체계적인 문서화 및 프로세스 관리 능력', 'ISO 인증 문서 작성 핵심 역할', '품질 검사 기준서 관리 전문성'],
      weaknesses: ['데이터 분석 도구 활용 역량 보통', '리더십 경험 제한적', '대외 커뮤니케이션 역량 보강 필요'],
      utilization: ['ISO 인증 문서 총괄', '품질 데이터 전산화 요구사항 정의', '품질 교육 자료 개발'],
      risk_factors: ['문서화 업무 편중으로 성장 정체 가능', '팀장 부재 시 리더십 공백', '기술적 성장 기회 제한'],
      development_priority: ['데이터 분석 기초 교육', '리더십 기초 과정', '품질 엔지니어 전문 자격'],
      market_value: { salary_assessment: '적정', competitiveness: '중' },
    },
    swot: {
      strengths: ['체계적 문서화', 'ISO 문서 전문성', '프로세스 관리'],
      weaknesses: ['데이터 분석 보통', '리더십 경험 제한', '대외 커뮤니케이션 보강'],
      opportunities: ['ISO 인증 리더', '전산화 프로젝트 참여', '품질 교육 전문가'],
      threats: ['문서 업무 편중', '성장 정체', '기술 변화 대응'],
    },
  },
  TS2600017: {
    analysis: {
      career_analysis: '권혁준 대리는 5년차 품질 엔지니어로, IT개발팀과 협업하여 품질 데이터 전산화 요구사항 정의를 주도하고 있습니다.',
      strengths: ['품질 데이터 전산화 요구사항 정의 주도', 'IT팀과의 협업 커뮤니케이션 우수', '검사 프로세스 개선 의지'],
      weaknesses: ['통계적 분석 역량 보강 필요', '프로젝트 관리 경험 부족', '품질 자동화 도구 활용 미숙'],
      utilization: ['품질 전산화 프로젝트 PL 역할', 'IT-품질 간 브릿지 역할', '품질 검사 프로세스 개선 리더'],
      risk_factors: ['프로젝트 지연 시 성과 인정 어려움', '업무 범위 확대에 따른 부담', '기술적 역량 성장 속도 관리'],
      development_priority: ['프로젝트 관리(PM) 기초', 'SQC 통계 분석 교육', '품질 자동화 도구 교육'],
      market_value: { salary_assessment: '적정', competitiveness: '중' },
    },
    swot: {
      strengths: ['전산화 요구사항 주도', 'IT 협업 능력', '프로세스 개선 의지'],
      weaknesses: ['통계 분석 부족', 'PM 경험 부족', '자동화 도구 미숙'],
      opportunities: ['전산화 PL 역할', 'IT-품질 브릿지', '프로세스 혁신 리더'],
      threats: ['프로젝트 지연 리스크', '업무 범위 확대', '기술 성장 속도'],
    },
  },
  TS2600018: {
    analysis: {
      career_analysis: '문소현 사원은 2년차 품질관리 담당자로, 검사 업무를 성실히 수행하며 기초 역량을 쌓고 있습니다.',
      strengths: ['성실하고 꼼꼼한 검사 업무 수행', '선배들로부터 빠른 학습', '품질 기준에 대한 높은 이해도'],
      weaknesses: ['독립적 판단 및 의사결정 경험 부족', '검사 외 업무 경험 제한', '기술적 깊이 부족'],
      utilization: ['검사 기준서 업데이트 보조', '품질 데이터 입력 및 관리', '품질 교육 수강 및 역량 확대'],
      risk_factors: ['단순 검사 업무 반복 시 성장 정체', '신입 이탈 위험', '동기 저하 관리 필요'],
      development_priority: ['품질 관련 자격증 취득', '통계 기초 교육', '보고서 작성 역량'],
      market_value: { salary_assessment: '적정', competitiveness: '중하' },
    },
    swot: {
      strengths: ['성실한 업무 수행', '빠른 학습', '품질 기준 이해'],
      weaknesses: ['독립 판단 부족', '경험 범위 제한', '기술 깊이 부족'],
      opportunities: ['자격증 취득으로 전문성', '데이터 관리 역할', '품질 엔지니어 성장'],
      threats: ['단순 업무 반복', '성장 정체', '동기 저하'],
    },
  },
  TS2600019: {
    analysis: {
      career_analysis: '장민수 팀장은 15년차 생산현장 전문가로, 전사 최장 근속자입니다. 설비 운용과 현장 관리 역량이 탁월하나, 연차 사용률 27%로 번아웃 리스크가 매우 높습니다.',
      strengths: ['15년 생산현장 경험과 설비 전문 지식 (전사 최장 근속)', '현장 인력 관리 및 교대 운영 노하우', '공정 최적화 및 생산성 향상에 핵심 기여'],
      weaknesses: ['연차 사용률 27%로 번아웃 고위험', '스마트팩토리/MES 등 디지털 역량 부족', '후임 양성 체계 미비'],
      utilization: ['생산 현장 총괄 및 설비 투자 의사결정', '생산 관리 교육 프로그램 강사', '스마트팩토리 도입 현장 자문'],
      risk_factors: ['번아웃으로 인한 갑작스런 퇴직 시 현장 마비 리스크', '연차 미사용 강제 소멸 리스크', '구본석 사원 안전교육 미이수 관리 책임'],
      development_priority: ['연차 사용 독려 및 업무 위임 체계 구축', 'MES/스마트팩토리 기초 교육', '후임 양성 계획 수립'],
      market_value: { salary_assessment: '적정', competitiveness: '상' },
    },
    swot: {
      strengths: ['15년 최장 근속, 현장 전문성', '설비 운용 탁월', '생산성 향상 핵심 기여'],
      weaknesses: ['연차 사용률 극저 (27%)', '디지털 역량 부족', '후임 양성 미비'],
      opportunities: ['스마트팩토리 도입 리더', '생산 관리 교육 강사', '현장 혁신 프로젝트 리드'],
      threats: ['번아웃 퇴직 리스크', '연차 강제 소멸', '디지털 전환 적응'],
    },
  },
  TS2600020: {
    analysis: {
      career_analysis: '홍유리 과장은 10년차 생산관리 담당자로, 공정 최적화 성과(불량률 전년 대비 8% 감소)가 돋보입니다.',
      strengths: ['공정 최적화 전문성 (불량률 8% 감소 달성)', '생산 데이터 분석 능력', '팀 내 실무 리더 역할'],
      weaknesses: ['생산 설비 IoT 연동 경험 부족', '프레젠테이션/보고 역량 보강 필요', '경영 관점의 생산 전략 수립 미흡'],
      utilization: ['공정 최적화 프로젝트 리더', '생산 데이터 분석 및 리포팅', '스마트팩토리 파일럿 운영 담당'],
      risk_factors: ['인력 부족 시 과부하 집중', '성장 경로 불명확 시 이직 고려', '디지털 전환 속도 대응'],
      development_priority: ['스마트팩토리/IoT 교육', '생산관리 전문가 자격', '비즈니스 프레젠테이션 과정'],
      market_value: { salary_assessment: '적정', competitiveness: '중상' },
    },
    swot: {
      strengths: ['공정 최적화 성과', '데이터 분석 능력', '실무 리더 역할'],
      weaknesses: ['IoT 연동 경험 부족', '보고 역량 보강', '전략적 사고 미흡'],
      opportunities: ['공정 최적화 전문가', '스마트팩토리 리더', '데이터 기반 생산 혁신'],
      threats: ['과부하 집중', '성장 경로 불확실', '디지털 전환 속도'],
    },
  },
  TS2600021: {
    analysis: {
      career_analysis: '남기훈 대리는 7년차 생산 담당자로, 현장 리더십과 후배 육성에 기여하고 있습니다.',
      strengths: ['현장 리더십과 작업자 관리 능력', '구본석 사원 멘토링 담당', '교대 근무 인수인계 관리'],
      weaknesses: ['설비 보전 전문성 보강 필요', '데이터 기반 생산 관리 미숙', '문서화 습관 부족'],
      utilization: ['현장 작업팀 리더 역할', '신입 작업자 교육 프로그램 운영', '교대 근무 체계 개선'],
      risk_factors: ['과장 승진 지연 시 동기 저하', '현장 업무 편중으로 역량 다양화 제한', '교대 근무에 따른 워라밸 이슈'],
      development_priority: ['설비 보전 기초 교육', '생산관리 자격증 취득', '데이터 분석 기초'],
      market_value: { salary_assessment: '적정', competitiveness: '중' },
    },
    swot: {
      strengths: ['현장 리더십', '후배 멘토링', '인수인계 관리'],
      weaknesses: ['설비 보전 보강', '데이터 관리 미숙', '문서화 부족'],
      opportunities: ['현장 팀리더 성장', '교육 프로그램 운영', '교대 체계 개선'],
      threats: ['승진 지연', '역량 다양화 제한', '워라밸 이슈'],
    },
  },
  TS2600022: {
    analysis: {
      career_analysis: '안미래 사원은 3년차 생산 담당자로, 생산라인 개선에 기여했으나 평가(D등급)에 이의제기 중입니다.',
      strengths: ['생산라인 개선 아이디어 제안 실적', '성실한 업무 태도', '품질 의식 양호'],
      weaknesses: ['평가 등급(D) 불만으로 동기 관리 필요', '기술적 깊이 부족', '커뮤니케이션 역량 보강 필요'],
      utilization: ['생산라인 개선 프로젝트 참여', '품질 검사 보조 역할', '현장 데이터 기록 담당'],
      risk_factors: ['평가 이의제기 결과에 따른 동기 변화', '낮은 등급 지속 시 이직 리스크', '성장 기회 부족 시 정체'],
      development_priority: ['기술 역량 강화 교육', '커뮤니케이션 스킬 과정', '성과 관리 코칭'],
      market_value: { salary_assessment: '적정', competitiveness: '중하' },
    },
    swot: {
      strengths: ['개선 아이디어 제안', '성실한 업무', '품질 의식'],
      weaknesses: ['평가 불만', '기술 깊이 부족', '커뮤니케이션 보강'],
      opportunities: ['개선 프로젝트 참여', '기술 역량 성장', '성과 개선 기회'],
      threats: ['이의제기 결과 영향', '낮은 등급 지속', '이직 리스크'],
    },
  },
  TS2600023: {
    analysis: {
      career_analysis: '구본석 사원은 1년차 신입 생산 담당자로, 남기훈 대리의 멘토링으로 현장 적응이 양호합니다. 산업안전보건·장애인 인식개선·괴롭힘 예방 교육 미이수가 즉시 해결 과제입니다.',
      strengths: ['현장 적응 속도 양호', '멘토(남기훈 대리)와의 관계 원만', '체력과 성실성 우수'],
      weaknesses: ['법정교육 3건 미이수 (산안법, 장애인, 괴롭힘)', '생산 설비 운용 경험 부족', '안전 의식 교육 시급'],
      utilization: ['생산라인 기본 작업 수행', '설비 조작 교육 프로그램 참여', '현장 안전 관리 보조'],
      risk_factors: ['산업안전보건 교육 미이수 — 현장 안전 법적 리스크', '신입 이탈 위험 시기', '교대 근무 적응'],
      development_priority: ['법정 필수교육 3건 즉시 이수 (최우선)', '생산 설비 기초 운용 교육', '안전 관리 기초'],
      market_value: { salary_assessment: '적정', competitiveness: '중하' },
    },
    swot: {
      strengths: ['현장 적응 양호', '멘토 관계 원만', '성실성'],
      weaknesses: ['법정교육 3건 미이수', '설비 운용 미숙', '안전 교육 부족'],
      opportunities: ['멘토링 빠른 성장', '설비 전문가 경로', '현장 리더 성장'],
      threats: ['안전교육 법적 리스크', '신입 이탈', '교대 적응'],
    },
  },
  TS2600024: {
    analysis: {
      career_analysis: '하은서 팀장은 11년차 풀스택 개발자 겸 팀 리더로, 사내 HR 시스템 자체 개발을 주도하며 외주 대비 약 40% 비용 절감을 달성했습니다.',
      strengths: ['풀스택 개발 역량 + 아키텍처 설계 능력', '사내 HR 시스템 자체 개발 성공 (40% 비용 절감)', '팀원 기술 성장에 대한 높은 관심'],
      weaknesses: ['보안(시큐어 코딩) 전문 인력 부재', 'DevOps/CI-CD 파이프라인 미성숙', '기술 부채 관리 체계 미흡'],
      utilization: ['사내 시스템 아키텍처 총괄', '기술 전략 수립 참여 (CTO 후보)', '사내 기술 교육 프로그램 운영'],
      risk_factors: ['핵심 기술 인재 이탈 시 시스템 운영 마비', '류재현 과장 초과근무(46h) 관리', '백도윤 사원 법정교육 4건 미이수 관리 책임'],
      development_priority: ['보안 전문가 채용 또는 시큐어 코딩 교육', 'DevOps/클라우드 역량 강화', '기술 부채 관리 프로세스 도입'],
      market_value: { salary_assessment: '적정', competitiveness: '상' },
    },
    swot: {
      strengths: ['풀스택 + 아키텍처 역량', 'HR 시스템 자체 개발 성공', '팀원 성장 관심'],
      weaknesses: ['보안 인력 부재', 'DevOps 미성숙', '기술 부채 관리'],
      opportunities: ['CTO 후보', '시스템 고도화 리드', '기술 조직 확대'],
      threats: ['핵심인재 이탈', '보안 사고 리스크', '기술 부채 누적'],
    },
  },
  TS2600025: {
    analysis: {
      career_analysis: '류재현 과장은 8년차 개발자로, React/Python 기술 스택의 깊이 있는 역량을 보유하고 있으나 주 46시간 초과근무가 지속되고 있습니다.',
      strengths: ['React/Python 기술 스택 전문성', '사내 HR 시스템 핵심 개발자', '코드 품질에 대한 높은 기준'],
      weaknesses: ['주 46시간 초과근무 지속', '업무 위임보다 직접 처리 선호', '문서화/지식 이전 습관 부족'],
      utilization: ['기술 아키텍처 리뷰 및 코드 리뷰 리더', '기술 면접관 역할', '사내 기술 교육 강사'],
      risk_factors: ['초과근무 지속 시 건강/이직 리스크', '1인 의존도 높은 코드 영역 존재', '백도윤 사원에 업무 이관 지연'],
      development_priority: ['업무 위임 및 팀 협업 코칭', '클라우드/DevOps 역량 확장', '시간 관리 프로그램'],
      market_value: { salary_assessment: '약간 낮음', competitiveness: '중상' },
    },
    swot: {
      strengths: ['React/Python 전문성', '핵심 시스템 개발자', '코드 품질 기준 높음'],
      weaknesses: ['초과근무 지속', '업무 위임 미숙', '문서화 부족'],
      opportunities: ['기술 리더 성장', '아키텍트 경로', '교육 역량 활용'],
      threats: ['초과근무 건강 리스크', '1인 의존 리스크', '이직 가능성'],
    },
  },
  TS2600026: {
    analysis: {
      career_analysis: '노하린 대리는 5년차 프론트엔드 개발자로, React 기술 스택에 전문성을 보유하고 있으며 UI/UX 구현 역량이 우수합니다.',
      strengths: ['React/TypeScript 프론트엔드 전문성', 'UI/UX 구현 품질 우수', '디자인 시스템 이해도 높음'],
      weaknesses: ['백엔드 역량 보강 필요', '프로젝트 리딩 경험 부족', '성능 최적화 경험 제한'],
      utilization: ['프론트엔드 아키텍처 설계 참여', 'UI 컴포넌트 라이브러리 구축', 'UX 개선 프로젝트 리드'],
      risk_factors: ['프론트엔드 전문가 시장 수요 높아 이직 리스크', '과장 승진 경로 불명확', '기술 스택 고착화'],
      development_priority: ['백엔드 기초 역량 확장 (Full-stack)', '성능 최적화 교육', '프로젝트 관리 기초'],
      market_value: { salary_assessment: '적정', competitiveness: '중상' },
    },
    swot: {
      strengths: ['React/TS 전문성', 'UI/UX 구현 우수', '디자인 시스템 이해'],
      weaknesses: ['백엔드 역량 부족', '리딩 경험 부족', '성능 최적화 제한'],
      opportunities: ['컴포넌트 라이브러리 구축', 'UX 개선 리드', 'Full-stack 성장'],
      threats: ['이직 리스크 높음', '승진 경로 불확실', '기술 고착화'],
    },
  },
  TS2600027: {
    analysis: {
      career_analysis: '전승우 대리는 4년차 백엔드 개발자로, Python/FastAPI 기술 스택의 실무 역량이 우수합니다.',
      strengths: ['Python/FastAPI 백엔드 전문성', 'API 설계 및 DB 모델링 역량', '코드 리뷰 적극 참여'],
      weaknesses: ['인프라/DevOps 경험 부족', '대규모 트래픽 처리 경험 제한', '기술 문서 작성 미흡'],
      utilization: ['백엔드 API 아키텍처 설계 참여', '데이터베이스 최적화 담당', '기술 블로그 운영 참여'],
      risk_factors: ['백엔드 개발자 시장 수요 높아 이직 리스크', '스킬 다양화 필요', '과장 승진 준비'],
      development_priority: ['클라우드 인프라 기초 (AWS)', '대규모 시스템 설계 교육', '기술 문서 작성 역량'],
      market_value: { salary_assessment: '적정', competitiveness: '중' },
    },
    swot: {
      strengths: ['Python/FastAPI 전문성', 'API 설계 역량', '코드 리뷰 적극'],
      weaknesses: ['인프라 경험 부족', '대규모 트래픽 경험 제한', '문서 작성 미흡'],
      opportunities: ['백엔드 아키텍트 성장', 'DB 최적화 전문가', '클라우드 역량 확장'],
      threats: ['이직 리스크', '스킬 다양화 필요', '기술 변화 속도'],
    },
  },
  TS2600028: {
    analysis: {
      career_analysis: '양세은 사원은 2년차 프론트엔드 개발자로, 최근 대시보드 리디자인 프로젝트에서 주도적 역할을 수행하며 빠르게 성장하고 있습니다.',
      strengths: ['대시보드 리디자인 프로젝트 주도적 수행', '코드 품질 양호', 'React/TypeScript 기초 역량 탄탄'],
      weaknesses: ['독립적 아키텍처 설계 경험 부족', '테스트 코드 작성 습관 미흡', '백엔드 연동 이해 보강 필요'],
      utilization: ['UI 컴포넌트 개발 담당', '디자인 시스템 구현 참여', '사용자 피드백 기반 UI 개선'],
      risk_factors: ['신입 이탈 위험 시기 (2년차)', '성장 기회 부족 시 동기 저하', '선배 개발자와의 기술 격차'],
      development_priority: ['테스트 코드 작성 교육', '백엔드 API 연동 심화', '디자인 패턴 학습'],
      market_value: { salary_assessment: '적정', competitiveness: '중' },
    },
    swot: {
      strengths: ['프로젝트 주도 수행', '코드 품질 양호', 'React/TS 기초 탄탄'],
      weaknesses: ['아키텍처 경험 부족', '테스트 습관 미흡', '백엔드 이해 제한'],
      opportunities: ['UI 전문가 성장', '디자인 시스템 구축', '프로젝트 리딩 기회'],
      threats: ['이탈 위험 시기', '성장 기회 부족', '기술 격차'],
    },
  },
  TS2600029: {
    analysis: {
      career_analysis: '백도윤 사원은 6개월차 최신입으로, 법정교육 4건 미이수가 가장 시급한 과제입니다. 류재현 과장으로부터 업무 이관을 받으며 성장 중입니다.',
      strengths: ['최신 기술 트렌드에 대한 높은 관심', '빠른 학습 의지', '류재현 과장으로부터 체계적 업무 이관 중'],
      weaknesses: ['법정교육 4건 미이수 (성희롱, 개인정보, 산안법, 장애인)', '실무 경험 전무한 수준', '독립적 업무 수행 불가'],
      utilization: ['류재현 과장 업무 부담 분산 대상', '기초 코드 작성 및 버그 수정', '사내 교육 프로그램 전량 이수'],
      risk_factors: ['법정교육 4건 미이수 — 과태료 리스크 최고 수준', '온보딩 프로세스 개선 필요 (6개월 경과 후에도 미이수)', '수습 기간 종료 후 정규 전환 평가 필요'],
      development_priority: ['법정 필수교육 4건 즉시 이수 (최최우선)', '개발 기초 역량 강화 (코드 리뷰 참여)', 'Git/협업 도구 활용 교육'],
      market_value: { salary_assessment: '적정', competitiveness: '중하' },
    },
    swot: {
      strengths: ['최신 기술 관심', '학습 의지', '체계적 이관 중'],
      weaknesses: ['법정교육 4건 미이수', '실무 경험 전무', '독립 수행 불가'],
      opportunities: ['류재현 과장 업무 이관으로 빠른 역량 축적', '신기술 프로젝트 참여', '정규직 전환 후 성장 가속'],
      threats: ['법정교육 과태료 (최고 리스크)', '온보딩 실패', '수습 종료 평가'],
    },
  },
};

// ========== Per-Employee Detail Data (education, career, certifications) ==========
const EMPLOYEE_DETAILS: Record<string, {
  education: Array<{ school: string; degree: string; major: string; gpa?: string; graduation_date?: string }>;
  career: Array<{ company: string; position: string; start_date: string; end_date: string }>;
  certifications: Array<{ name: string; date: string; issuer: string }>;
}> = {
  TS2600001: {
    education: [{ school: '고려대학교', degree: '학사', major: '경영학과', gpa: '3.6', graduation_date: '2002-02' }],
    career: [
      { company: '삼성물산', position: '경영지원 대리', start_date: '2004-03', end_date: '2008-12' },
      { company: 'LG CNS', position: '인사기획 과장', start_date: '2009-01', end_date: '2012-02' },
    ],
    certifications: [{ name: '공인노무사(2차)', date: '2008-11', issuer: '한국산업인력공단' }],
  },
  TS2600002: {
    education: [{ school: '이화여자대학교', degree: '학사', major: '경영학과', gpa: '3.8', graduation_date: '2018-02' }],
    career: [{ company: '넥슨코리아', position: '총무팀 사원', start_date: '2018-03', end_date: '2019-12' }],
    certifications: [{ name: '전산회계 1급', date: '2019-05', issuer: '한국세무사회' }],
  },
  TS2600003: {
    education: [{ school: '한양대학교', degree: '학사', major: '경영학과', gpa: '3.4', graduation_date: '2024-02' }],
    career: [],
    certifications: [{ name: '컴퓨터활용능력 1급', date: '2023-06', issuer: '대한상공회의소' }],
  },
  TS2600004: {
    education: [{ school: '연세대학교', degree: '학사', major: '경영학과', gpa: '3.7', graduation_date: '2006-02' }],
    career: [
      { company: '현대모비스', position: '영업 대리', start_date: '2006-03', end_date: '2010-06' },
      { company: 'SK하이닉스', position: '기술영업 과장', start_date: '2010-07', end_date: '2014-06' },
    ],
    certifications: [{ name: '경영지도사(마케팅)', date: '2012-11', issuer: '한국산업인력공단' }],
  },
  TS2600005: {
    education: [{ school: '한양대학교', degree: '학사', major: '산업공학과', gpa: '3.5', graduation_date: '2012-02' }],
    career: [{ company: '두산인프라코어', position: '기술영업 사원', start_date: '2012-03', end_date: '2017-08' }],
    certifications: [{ name: '산업안전기사', date: '2015-08', issuer: '한국산업인력공단' }],
  },
  TS2600006: {
    education: [{ school: '숙명여자대학교', degree: '학사', major: '국제통상학과', gpa: '3.6', graduation_date: '2019-02' }],
    career: [{ company: '코오롱인더스트리', position: '영업지원 사원', start_date: '2019-03', end_date: '2021-02' }],
    certifications: [],
  },
  TS2600007: {
    education: [{ school: '중앙대학교', degree: '학사', major: '경영학과', gpa: '3.3', graduation_date: '2024-02' }],
    career: [],
    certifications: [],
  },
  TS2600008: {
    education: [{ school: '동국대학교', degree: '학사', major: '경영학과', gpa: '3.5', graduation_date: '2025-02' }],
    career: [],
    certifications: [{ name: 'TOEIC 850', date: '2024-08', issuer: 'ETS' }],
  },
  TS2600009: {
    education: [
      { school: '서울대학교', degree: '학사', major: '전자공학과', gpa: '3.9', graduation_date: '2004-02' },
      { school: 'KAIST', degree: '석사', major: '전자공학과', gpa: '4.1', graduation_date: '2006-02' },
    ],
    career: [
      { company: '삼성전자 종합기술원', position: '선임연구원', start_date: '2006-03', end_date: '2010-06' },
      { company: 'LG전자 R&D센터', position: '책임연구원', start_date: '2010-07', end_date: '2012-12' },
    ],
    certifications: [
      { name: '정보처리기사', date: '2005-11', issuer: '한국산업인력공단' },
      { name: '특허 3건 보유', date: '2015-03', issuer: '특허청' },
    ],
  },
  TS2600010: {
    education: [{ school: '포항공과대학교', degree: '학사', major: '신소재공학과', gpa: '3.7', graduation_date: '2010-02' }],
    career: [{ company: '포스코 기술연구원', position: '연구원', start_date: '2010-03', end_date: '2016-03' }],
    certifications: [{ name: '정보처리기사', date: '2011-05', issuer: '한국산업인력공단' }],
  },
  TS2600011: {
    education: [{ school: '성균관대학교', degree: '학사', major: '기계공학과', gpa: '3.5', graduation_date: '2016-02' }],
    career: [{ company: '현대중공업', position: '품질관리 사원', start_date: '2016-07', end_date: '2019-06' }],
    certifications: [{ name: '품질관리기사', date: '2018-05', issuer: '한국산업인력공단' }],
  },
  TS2600012: {
    education: [{ school: '아주대학교', degree: '학사', major: '전자공학과', gpa: '3.6', graduation_date: '2018-02' }],
    career: [],
    certifications: [{ name: '정보처리기사', date: '2019-11', issuer: '한국산업인력공단' }],
  },
  TS2600013: {
    education: [{ school: '건국대학교', degree: '학사', major: '소프트웨어학과', gpa: '3.4', graduation_date: '2022-02' }],
    career: [{ company: '카카오엔터프라이즈', position: '개발 인턴', start_date: '2021-07', end_date: '2021-12' }],
    certifications: [{ name: '정보처리기사', date: '2022-05', issuer: '한국산업인력공단' }],
  },
  TS2600014: {
    education: [{ school: '숭실대학교', degree: '학사', major: '컴퓨터공학과', gpa: '3.7', graduation_date: '2024-02' }],
    career: [],
    certifications: [{ name: 'SQLD', date: '2023-09', issuer: '한국데이터산업진흥원' }],
  },
  TS2600015: {
    education: [
      { school: '인하대학교', degree: '학사', major: '산업공학과', gpa: '3.5', graduation_date: '2005-02' },
      { school: '인하대학교', degree: '석사', major: '품질경영공학과', gpa: '4.0', graduation_date: '2007-02' },
    ],
    career: [
      { company: '두산중공업', position: 'QA 대리', start_date: '2007-03', end_date: '2011-06' },
      { company: '삼성SDI', position: '품질관리 과장', start_date: '2011-07', end_date: '2013-08' },
    ],
    certifications: [
      { name: '품질관리기술사', date: '2012-11', issuer: '한국산업인력공단' },
      { name: 'ISO 9001 심사원', date: '2014-03', issuer: 'KAB' },
    ],
  },
  TS2600016: {
    education: [{ school: '경희대학교', degree: '학사', major: '산업경영공학과', gpa: '3.6', graduation_date: '2012-02' }],
    career: [{ company: '한화토탈', position: 'QC 사원', start_date: '2012-03', end_date: '2017-12' }],
    certifications: [{ name: '품질경영기사', date: '2014-11', issuer: '한국산업인력공단' }],
  },
  TS2600017: {
    education: [{ school: '동국대학교', degree: '학사', major: '산업시스템공학과', gpa: '3.4', graduation_date: '2019-02' }],
    career: [{ company: '한국타이어', position: '품질보증 사원', start_date: '2019-03', end_date: '2021-06' }],
    certifications: [{ name: '품질경영기사', date: '2020-05', issuer: '한국산업인력공단' }],
  },
  TS2600018: {
    education: [{ school: '세종대학교', degree: '학사', major: '화학공학과', gpa: '3.5', graduation_date: '2023-08' }],
    career: [],
    certifications: [{ name: '위험물산업기사', date: '2023-05', issuer: '한국산업인력공단' }],
  },
  TS2600019: {
    education: [{ school: '영남대학교', degree: '학사', major: '기계공학과', gpa: '3.3', graduation_date: '2003-02' }],
    career: [
      { company: '포스코', position: '생산기술 대리', start_date: '2003-03', end_date: '2008-12' },
      { company: '현대제철', position: '공정관리 과장', start_date: '2009-01', end_date: '2011-02' },
    ],
    certifications: [
      { name: '산업안전기사', date: '2006-11', issuer: '한국산업인력공단' },
      { name: '기계정비산업기사', date: '2008-05', issuer: '한국산업인력공단' },
    ],
  },
  TS2600020: {
    education: [{ school: '부산대학교', degree: '학사', major: '화학공학과', gpa: '3.6', graduation_date: '2010-02' }],
    career: [{ company: 'LG화학', position: '공정엔지니어', start_date: '2010-03', end_date: '2015-12' }],
    certifications: [{ name: '화학분석기사', date: '2012-05', issuer: '한국산업인력공단' }],
  },
  TS2600021: {
    education: [{ school: '울산대학교', degree: '학사', major: '기계공학과', gpa: '3.4', graduation_date: '2015-02' }],
    career: [{ company: '현대자동차', position: '생산라인 사원', start_date: '2015-03', end_date: '2019-02' }],
    certifications: [{ name: '산업기사(기계)', date: '2016-11', issuer: '한국산업인력공단' }],
  },
  TS2600022: {
    education: [{ school: '한밭대학교', degree: '학사', major: '기계공학과', gpa: '3.3', graduation_date: '2022-02' }],
    career: [{ company: 'LS산전', position: '생산관리 사원', start_date: '2022-03', end_date: '2023-06' }],
    certifications: [],
  },
  TS2600023: {
    education: [{ school: '충북대학교', degree: '학사', major: '기계공학과', gpa: '3.2', graduation_date: '2024-08' }],
    career: [],
    certifications: [],
  },
  TS2600024: {
    education: [
      { school: '서울대학교', degree: '학사', major: '컴퓨터공학과', gpa: '3.8', graduation_date: '2007-02' },
      { school: 'KAIST', degree: '석사', major: '전산학과', gpa: '4.2', graduation_date: '2009-02' },
    ],
    career: [
      { company: 'NHN(현 네이버)', position: '백엔드 개발자', start_date: '2009-03', end_date: '2012-12' },
      { company: '카카오', position: '시니어 개발자', start_date: '2013-01', end_date: '2014-12' },
    ],
    certifications: [
      { name: '정보관리기술사', date: '2013-11', issuer: '한국산업인력공단' },
      { name: 'AWS Solutions Architect Professional', date: '2020-06', issuer: 'Amazon Web Services' },
    ],
  },
  TS2600025: {
    education: [{ school: '서울시립대학교', degree: '학사', major: '컴퓨터과학과', gpa: '3.6', graduation_date: '2014-02' }],
    career: [{ company: '삼성SDS', position: '풀스택 개발자', start_date: '2014-03', end_date: '2018-06' }],
    certifications: [
      { name: '정보처리기사', date: '2014-11', issuer: '한국산업인력공단' },
      { name: 'AWS Solutions Architect Associate', date: '2021-03', issuer: 'Amazon Web Services' },
    ],
  },
  TS2600026: {
    education: [{ school: '이화여자대학교', degree: '학사', major: '컴퓨터공학과', gpa: '3.7', graduation_date: '2019-02' }],
    career: [{ company: '라인플러스', position: '프론트엔드 개발자', start_date: '2019-03', end_date: '2021-08' }],
    certifications: [{ name: '정보처리기사', date: '2019-05', issuer: '한국산업인력공단' }],
  },
  TS2600027: {
    education: [{ school: '경북대학교', degree: '학사', major: '소프트웨어학과', gpa: '3.5', graduation_date: '2020-02' }],
    career: [{ company: '우아한형제들', position: '백엔드 개발자', start_date: '2020-03', end_date: '2022-02' }],
    certifications: [{ name: '정보처리기사', date: '2020-05', issuer: '한국산업인력공단' }],
  },
  TS2600028: {
    education: [{ school: '서울여자대학교', degree: '학사', major: '디지털미디어학과', gpa: '3.8', graduation_date: '2024-02' }],
    career: [],
    certifications: [{ name: '웹디자인기능사', date: '2023-06', issuer: '한국산업인력공단' }],
  },
  TS2600029: {
    education: [{ school: '한국공학대학교', degree: '학사', major: '컴퓨터공학과', gpa: '3.4', graduation_date: '2025-08' }],
    career: [],
    certifications: [],
  },
};

const ages = EMPLOYEES.map(e => e.age);
const teamDist: Record<string, number> = {};
const posDist: Record<string, number> = {};
const regionDist: Record<string, number> = {};
const regionSubDist: Record<string, Record<string, number>> = {};
EMPLOYEES.forEach(e => {
  teamDist[e.team] = (teamDist[e.team] || 0) + 1;
  posDist[e.position] = (posDist[e.position] || 0) + 1;
  const parts = e.region.split(' ');
  const province = parts[0];
  const sub = parts[1] || '';
  regionDist[province] = (regionDist[province] || 0) + 1;
  if (sub) {
    if (!regionSubDist[province]) regionSubDist[province] = {};
    regionSubDist[province][sub] = (regionSubDist[province][sub] || 0) + 1;
  }
});

export const demoData = {
  // ========== Dashboard & Employees ==========
  employees: {
    employees: EMPLOYEES.map(e => ({
      id: e.id,
      employee_id: e.id,
      name: e.name,
      team: e.team,
      position: e.position,
      join_date: e.hire_date,
      hire_date: e.hire_date,
      years_of_service: Math.round((Date.now() - new Date(e.hire_date).getTime()) / (365.25 * 24 * 3600 * 1000) * 10) / 10,
      age: e.age,
      gender: e.gender,
      salary: e.salary,
      region: e.region,
      status: e.id === 'TS2600029' ? 'probation' : 'active',
      photo_url: null,
      company_id: 1,
      company_name: '티사이언티픽',
      company_code: 'TSCORP',
    })),
    total: EMPLOYEES.length,
  },

  statistics: {
    total_employees: EMPLOYEES.length,
    total_teams: 6,
    average_age: Math.round(ages.reduce((a, b) => a + b, 0) / ages.length * 10) / 10,
    team_distribution: teamDist,
    position_distribution: posDist,
    age_distribution: {
      min: Math.min(...ages),
      max: Math.max(...ages),
      ages: ages,
    },
  },

  regionDistribution: {
    region_distribution: regionDist,
    sub_regions: regionSubDist,
    total_with_address: EMPLOYEES.length,
    total_without_address: 0,
    total_employees: EMPLOYEES.length,
  },

  insights: {
    summary: 'TS Scientific은 29명 규모의 기술 중심 기업으로, 6개 팀이 균형 잡힌 구조를 갖추고 있습니다. 평균 근속 연수 5.2년, 평균 연령 33.2세로 비교적 젊은 조직입니다.',
    structural_issues: [
      '연구개발팀(6명)과 IT개발팀(6명)의 인원이 가장 많아 기술 중심 조직 특성이 뚜렷합니다.',
      '관리직(부장 1명)이 적어 중간관리 레이어 보강이 필요합니다.',
      '신입(1년 미만) 3명이 수습 중으로, 온보딩 프로그램 강화가 권장됩니다.',
    ],
    skill_gaps: [
      '데이터 분석 역량 부족 — 연구개발팀에 데이터 사이언티스트 채용 권장',
      '프로젝트 관리(PM) 역량 — 과장급 PM 교육 이수 필요',
      'AI/ML 관련 기술 역량이 IT개발팀에 집중되어 있어 타 팀 전파 필요',
    ],
    risk_points: [
      '영업팀 초과근무 비율이 높아 52시간 상한 모니터링 필요',
      '경영지원팀 김도현 부장(근속 14년) 퇴직 시 업무 공백 리스크',
      '신입 3명(백도윤, 한지수, 구본석)의 조기 이탈 방지를 위한 멘토링 필요',
    ],
    immediate_actions: [
      '영업팀 초과근무 현황 점검 및 업무 재배분',
      '신입사원 온보딩 프로그램 점검 (1개월/3개월/6개월 체크포인트)',
      '법정 필수교육 미이수자 즉시 교육 일정 수립',
    ],
    hiring_strategy: [
      '연구개발팀 데이터 사이언티스트 1명 채용 (3월 목표)',
      '영업팀 대리급 1명 보강으로 업무 부하 분산',
      '품질관리팀 경력 대리 1명 채용으로 전문성 강화',
    ],
    cost_efficiency: '인건비 총액 약 13.7억원, 1인당 평균 약 4,700만원. 업계 평균(5,200만원) 대비 90% 수준으로 경쟁력 확보 필요. 핵심인재 이탈 방지를 위한 보상 패키지 개선 권장.',
  },

  // ========== Organization ==========
  organizationTree: {
    tree: [{
      id: 1, name: 'TS Scientific', unit_type: 'company', parent_id: null, head_employee_id: 'TS2600001', member_count: 29,
      children: [
        { id: 2, name: '경영지원팀', unit_type: 'team', parent_id: 1, head_employee_id: 'TS2600001', member_count: 3, children: [] },
        { id: 3, name: '영업팀', unit_type: 'team', parent_id: 1, head_employee_id: 'TS2600004', member_count: 5, children: [] },
        { id: 4, name: '연구개발팀', unit_type: 'team', parent_id: 1, head_employee_id: 'TS2600009', member_count: 6, children: [] },
        { id: 5, name: '품질관리팀', unit_type: 'team', parent_id: 1, head_employee_id: 'TS2600015', member_count: 4, children: [] },
        { id: 6, name: '생산팀', unit_type: 'team', parent_id: 1, head_employee_id: 'TS2600019', member_count: 5, children: [] },
        { id: 7, name: 'IT개발팀', unit_type: 'team', parent_id: 1, head_employee_id: 'TS2600024', member_count: 6, children: [] },
      ],
    }],
    total: 7,
  },

  organizationStats: {
    total_units: 7,
    total_employees: 29,
    team_count: 6,
    avg_team_size: 4.8,
  },

  // ========== Personnel Changes ==========
  personnelChanges: {
    changes: [
      { id: 1, employee_id: 'TS2600029', employee_name: '백도윤', change_type: 'join', previous_value: '', new_value: 'IT개발팀 사원', change_date: '2025-09-01', formatted_date: '2025년 9월 1일', created_at: 1724544000 },
      { id: 2, employee_id: 'TS2600023', employee_name: '구본석', change_type: 'join', previous_value: '', new_value: '생산팀 사원', change_date: '2025-01-02', formatted_date: '2025년 1월 2일', created_at: 1703030400 },
      { id: 3, employee_id: 'TS2600005', employee_name: '정우진', change_type: 'position_change', previous_value: '대리', new_value: '과장', change_date: '2025-01-01', formatted_date: '2025년 1월 1일', created_at: 1702598400 },
      { id: 4, employee_id: 'TS2600011', employee_name: '오재혁', change_type: 'team_change', previous_value: '품질관리팀', new_value: '연구개발팀', change_date: '2024-10-01', formatted_date: '2024년 10월 1일', created_at: 1726790400 },
      { id: 5, employee_id: 'TS2600008', employee_name: '한지수', change_type: 'join', previous_value: '', new_value: '영업팀 사원', change_date: '2025-03-03', formatted_date: '2025년 3월 3일', created_at: 1708387200 },
      { id: 6, employee_id: 'TS2600007', employee_name: '윤성민', change_type: 'join', previous_value: '', new_value: '영업팀 사원', change_date: '2024-09-01', formatted_date: '2024년 9월 1일', created_at: 1724112000 },
      { id: 7, employee_id: 'TS2600010', employee_name: '송예진', change_type: 'position_change', previous_value: '대리', new_value: '과장', change_date: '2024-01-01', formatted_date: '2024년 1월 1일', created_at: 1701388800 },
      { id: 8, employee_id: 'TS2600016', employee_name: '유지현', change_type: 'position_change', previous_value: '대리', new_value: '과장', change_date: '2024-01-01', formatted_date: '2024년 1월 1일', created_at: 1701388800 },
    ],
    total: 8,
  },

  // ========== Annual Leave ==========
  annualLeaveAlerts: {
    expiring_60days: { count: 2, risk_level: 'medium', action: '연차 사용 촉진 1차 통보 필요 (근로기준법 제61조)' },
    expiring_30days: { count: 1, risk_level: 'high', action: '연차 사용 촉진 2차 통보 필요 (서면 통보)' },
    expiring_7days: { count: 0, risk_level: 'none', action: null },
    expiring_soon: [
      { employee_id: 'TS2600011', employee_name: '오재혁', remaining_days: 12, expiry_date: '2026-06-30', days_until_expiry: 143 },
      { employee_id: 'TS2600005', employee_name: '정우진', remaining_days: 10, expiry_date: '2026-08-31', days_until_expiry: 205 },
    ],
    low_usage: [
      { employee_id: 'TS2600009', employee_name: '임태현', usage_rate: 20, used: 3, granted: 15 },
      { employee_id: 'TS2600019', employee_name: '장민수', usage_rate: 27, used: 4, granted: 15 },
    ],
    total_alerts: 4,
  },

  annualLeaveSummary: (() => {
    const balances = EMPLOYEES.map(e => {
      const years = Math.round((Date.now() - new Date(e.hire_date).getTime()) / (365.25 * 24 * 3600 * 1000));
      const granted = years < 1 ? Math.min(11, Math.max(1, Math.floor((Date.now() - new Date(e.hire_date).getTime()) / (30 * 24 * 3600 * 1000)))) : Math.min(25, 15 + Math.floor((years - 1) / 2));
      const seed = parseInt(e.id.slice(-5), 10);
      const used = Math.floor(granted * (0.4 + (seed * 7 % 10) / 25));
      const promotion = seed % 5 === 0 ? 'first_notice' : seed % 8 === 0 ? 'second_notice' : 'none';
      return {
        employee_id: e.id, employee_name: e.name, team: e.team,
        granted, used, remaining: granted - used,
        expiry_date: '2026-12-31',
        promotion_status: promotion,
        usage_rate: Math.round(used / granted * 100),
        data: JSON.stringify({ name: e.name }),
      };
    });
    return {
      employee_count: 29,
      total_granted: balances.reduce((s, b) => s + b.granted, 0),
      total_used: balances.reduce((s, b) => s + b.used, 0),
      total_remaining: balances.reduce((s, b) => s + b.remaining, 0),
      avg_usage_rate: Math.round(balances.reduce((s, b) => s + b.usage_rate, 0) / balances.length * 10) / 10,
      balances,
      details: balances,
    };
  })(),

  // ========== Overtime ==========
  overtimeRisks: {
    critical: {
      count: 1,
      risk_level: 'critical',
      legal_warning: '근로기준법 제53조 위반 — 주 52시간 초과. 사업주 2년 이하 징역 또는 2천만원 이하 벌금',
      items: [
        { employee_id: 'TS2600005', team: '영업팀', regular_hours: 40, overtime_hours: 11.5, total_hours: 51.5, week_start: '2026-02-02', consecutive_weeks: 3, data: JSON.stringify({ name: '정우진' }) },
      ],
    },
    high: {
      count: 1,
      risk_level: 'high',
      action: '초과근무 사전 승인 의무화, 업무량 분산 필요',
      items: [
        { employee_id: 'TS2600006', team: '영업팀', regular_hours: 40, overtime_hours: 9, total_hours: 49, week_start: '2026-02-02', consecutive_weeks: 2, data: JSON.stringify({ name: '강하은' }) },
      ],
    },
    warning: {
      count: 2,
      risk_level: 'medium',
      action: '근무시간 추이 모니터링 필요',
      items: [
        { employee_id: 'TS2600010', team: '연구개발팀', regular_hours: 40, overtime_hours: 7.5, total_hours: 47.5, week_start: '2026-02-02', consecutive_weeks: 1, data: JSON.stringify({ name: '송예진' }) },
        { employee_id: 'TS2600025', team: 'IT개발팀', regular_hours: 40, overtime_hours: 6, total_hours: 46, week_start: '2026-02-02', consecutive_weeks: 1, data: JSON.stringify({ name: '류재현' }) },
      ],
    },
    total: 4,
  },

  overtimeStats: {
    week_start: '2026-02-02',
    total_employees: 29,
    avg_hours: 42.3,
    critical_count: 1,
    high_count: 1,
    over_40: 18,
    over_48: 2,
    over_52: 1,
    team_stats: [
      { team: '경영지원팀', employee_count: 5, avg_hours: 40.2, max_hours: 42.5, at_risk: 0 },
      { team: '영업팀', employee_count: 5, avg_hours: 46.8, max_hours: 51.5, at_risk: 2 },
      { team: '연구개발팀', employee_count: 6, avg_hours: 44.1, max_hours: 47.5, at_risk: 1 },
      { team: '품질관리팀', employee_count: 4, avg_hours: 41.5, max_hours: 43.0, at_risk: 0 },
      { team: '생산팀', employee_count: 5, avg_hours: 42.0, max_hours: 44.5, at_risk: 0 },
      { team: 'IT개발팀', employee_count: 4, avg_hours: 43.5, max_hours: 46.0, at_risk: 1 },
    ],
    details: EMPLOYEES.map(e => {
      const seed = parseInt(e.id.slice(-5), 10);
      const base = e.team === '영업팀' ? 46 : e.team === '연구개발팀' ? 43 : e.team === 'IT개발팀' ? 42 : 40;
      const hours = Math.round((base + (seed * 3 % 7) - 2) * 10) / 10;
      return { employee_id: e.id, employee_name: e.name, team: e.team, weekly_hours: hours };
    }),
  },

  // ========== Severance ==========
  severanceAlerts: {
    overdue: { count: 0, risk_level: 'none', legal_warning: null },
    upcoming_deadline: { count: 1, risk_level: 'medium', action: '14일 내 퇴직금 지급 필요 (퇴직급여보장법 제9조)' },
    approaching: [
      { employee_id: 'TS2600001', employee_name: '김도현', team: '경영지원팀', years_of_service: 14.0, estimated_amount: 84000000 },
    ],
    unpaid: [],
    total_alerts: 1,
  },

  severances: {
    items: [
      {
        employee_id: 'TS2600029', team: 'IT개발팀', termination_date: '2026-03-31',
        years_worked: 0.5, severance_amount: 2100000, payment_deadline: '2026-04-14',
        payment_status: 'pending', risk_level: 'medium',
        data: JSON.stringify({ name: '백도윤' }),
      },
    ],
    total: 1,
  },

  // ========== Training ==========
  trainingAlerts: {
    overdue: {
      count: 4,
      risk_level: 'high',
      legal_warning: '법정 필수교육 미이수 시 사업주에게 과태료 부과 (최대 500만원)',
      items: [
        { employee_id: 'TS2600007', employee_name: '윤성민', course_name: '개인정보보호 교육', due_date: '2026-01-31', days_overdue: 8 },
        { employee_id: 'TS2600008', employee_name: '한지수', course_name: '성희롱 예방 교육', due_date: '2026-01-31', days_overdue: 8 },
        { employee_id: 'TS2600023', employee_name: '구본석', course_name: '산업안전보건 교육', due_date: '2026-01-31', days_overdue: 8 },
        { employee_id: 'TS2600029', employee_name: '백도윤', course_name: '성희롱 예방 교육', due_date: '2026-01-31', days_overdue: 8 },
      ],
    },
    upcoming: [
      { employee_id: 'TS2600006', employee_name: '강하은', course_name: '장애인 인식개선 교육', due_date: '2026-03-31', days_until_due: 51 },
    ],
    total_alerts: 5,
  },

  trainingSummary: {
    total_employees: 29,
    mandatory_courses_count: 6,
    overall_completion_rate: 81.6,
    course_stats: [
      { course_name: '성희롱 예방 교육', legal_basis: '남녀고용평등법 제13조', completed: 26, not_completed: 3, completion_rate: 89.7, penalty_amount: 5000000 },
      { course_name: '개인정보보호 교육', legal_basis: '개인정보보호법 제28조', completed: 25, not_completed: 4, completion_rate: 86.2, penalty_amount: 5000000 },
      { course_name: '산업안전보건 교육', legal_basis: '산업안전보건법 제29조', completed: 22, not_completed: 7, completion_rate: 75.9, penalty_amount: 5000000 },
      { course_name: '장애인 인식개선 교육', legal_basis: '장애인고용촉진법 제5조의3', completed: 20, not_completed: 9, completion_rate: 69.0, penalty_amount: 3000000 },
      { course_name: '퇴직연금 교육', legal_basis: '근로자퇴직급여보장법 제32조', completed: 27, not_completed: 2, completion_rate: 93.1, penalty_amount: 1000000 },
      { course_name: '직장 내 괴롭힘 예방', legal_basis: '근로기준법 제76조의2', completed: 22, not_completed: 7, completion_rate: 75.9, penalty_amount: 0 },
    ],
    team_stats: [
      { team: '경영지원팀', employee_count: 5, fully_compliant: 5, compliance_rate: 100 },
      { team: '영업팀', employee_count: 5, fully_compliant: 3, compliance_rate: 60 },
      { team: '연구개발팀', employee_count: 6, fully_compliant: 5, compliance_rate: 83.3 },
      { team: '품질관리팀', employee_count: 4, fully_compliant: 4, compliance_rate: 100 },
      { team: '생산팀', employee_count: 5, fully_compliant: 3, compliance_rate: 60 },
      { team: 'IT개발팀', employee_count: 4, fully_compliant: 2, compliance_rate: 50 },
    ],
  },

  trainingCourses: {
    courses: [
      { id: 1, course_name: '성희롱 예방 교육', is_mandatory: true, frequency: 'annual', duration_hours: 1, legal_basis: '남녀고용평등법 제13조', penalty_amount: 5000000, description: '직장 내 성희롱 예방을 위한 법정 필수교육' },
      { id: 2, course_name: '개인정보보호 교육', is_mandatory: true, frequency: 'annual', duration_hours: 1, legal_basis: '개인정보보호법 제28조', penalty_amount: 5000000, description: '개인정보 처리에 관한 법정 필수교육' },
      { id: 3, course_name: '산업안전보건 교육', is_mandatory: true, frequency: 'quarterly', duration_hours: 2, legal_basis: '산업안전보건법 제29조', penalty_amount: 5000000, description: '산업재해 예방을 위한 법정 필수교육' },
      { id: 4, course_name: '장애인 인식개선 교육', is_mandatory: true, frequency: 'annual', duration_hours: 1, legal_basis: '장애인고용촉진법 제5조의3', penalty_amount: 3000000, description: '장애인 고용 촉진을 위한 법정 필수교육' },
      { id: 5, course_name: '퇴직연금 교육', is_mandatory: true, frequency: 'annual', duration_hours: 1, legal_basis: '근로자퇴직급여보장법 제32조', penalty_amount: 1000000, description: '퇴직연금제도 안내 법정교육' },
      { id: 6, course_name: '직장 내 괴롭힘 예방', is_mandatory: true, frequency: 'annual', duration_hours: 1, legal_basis: '근로기준법 제76조의2', penalty_amount: 0, description: '직장 내 괴롭힘 방지 법정교육' },
    ],
    total: 6,
  },

  // ========== Teams & Analysis ==========
  teams: {
    teams: ['경영지원팀', '영업팀', '연구개발팀', '품질관리팀', '생산팀', 'IT개발팀'],
  },

  teamAnalysis: {
    team_name: '연구개발팀',
    member_count: 6,
    avg_age: 33.7,
    avg_tenure: 5.8,
    analysis: '연구개발팀은 6명으로 구성된 핵심 기술 팀입니다. 팀장 임태현(13년차)의 리더십 아래 안정적으로 운영 중이나, 초과근무(평균 47.5h/주) 관리가 필요합니다. 신입 신지은의 빠른 적응이 관찰되며, 데이터 분석 역량 보강을 위한 추가 채용이 권장됩니다.',
    strengths: ['높은 기술 역량', '팀 내 지식 공유 문화', '안정적인 근속률'],
    weaknesses: ['초과근무 비율 높음', '데이터 분석 인력 부족'],
    recommendations: ['업무 부하 분산을 위한 인력 보강', 'AI/ML 교육 프로그램 도입'],
  },
};

// Helper to get pre-built analysis for a specific employee
export const getEmployeeAnalysis = (employeeId: string): { analysis?: any; swot?: any } => {
  const data = EMPLOYEE_ANALYSES[employeeId];
  if (!data) return {};
  return { analysis: data.analysis, swot: data.swot };
};

// Helper to get per-employee detail data (education, career, certifications)
export const getEmployeeDetails = (employeeId: string) => {
  const detail = EMPLOYEE_DETAILS[employeeId];
  if (!detail) return { education: [], career: [], certifications: [] };
  return detail;
};

// Re-export sub-module data for convenience
export * from './teams';
export * from './personnel';
export * from './evaluation';
export * from './organization';
export * from './compliance';
export * from './payroll';
export * from './workforce';
